<script>
  import { currentLang } from "../src/stores.js";

  export let info;
  export let center;
</script>

<p class="info" class:center>
  {info && info[$currentLang] ? info[$currentLang] : ""}
</p>

<style>
  .info {
    padding: 0 20px;
    max-width: 700px;
    margin: 50px auto 0;
    font-weight: 200;
    line-height: 1.8rem;
  }

  .info.center {
    text-align: center;
  }
</style>
